import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";

const MenuContent = ({showLogin, onClickOption1, onClickOption2, image1, image2}) => {
  return (
    <>
      <MenuOptionsContainer onClick={onClickOption1}>
        <MenuText>{showLogin ? 'Login' : 'My Reservation'}</MenuText>
        <MenuImage src={image1} />
      </MenuOptionsContainer>
      <Line />
      <MenuOptionsContainer onClick={onClickOption2}>
        <MenuText>{showLogin ? 'Sign Up' : 'Logout'}</MenuText>
        <MenuImage src={image2} />
      </MenuOptionsContainer>
    </>
  );
};

const MenuOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  // width: 100%;
  padding: 0.6rem 0.8rem 0.6rem 3.4rem;
  cursor: default;
`;

const MenuText = styled.span`
  display: flex;
`;
const MenuImage = styled.img`
  width: 1rem;
  height: 1rem;
`;
const Line = styled.div`
  width: "100%";
  border: 0.1px solid ${Colors.lightBlack5};
`;

export default MenuContent;
